module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/subscribers/edit-subscribers/edit-subscribers.component.scss
// module id = ./src/app/subscribers/edit-subscribers/edit-subscribers.component.scss
// module chunks = main